<template>
  <div id="bullStrategy">
      <!-- 导航栏和搜索框头部部分 -->
      <v-header  :selectedItemVal="2" ref="header"></v-header>
      
	  <div class="main">
		  <div class="bullStrategy">
			  <div class="page_tag">
				  <div class="page_tag">
				  	<h2>
				  		首页 &nbsp;> &nbsp; 牛策略
				  	</h2>
				  </div>
			  </div>
			  <div class="page_content">
				  <v-strategyList :strategyData="strategyList"></v-strategyList>
			  </div>
			  <div class="paginate">
				<el-pagination
					background
					:layout="paginate.layout"
					:page-count="paginate.pageCount" 
					:hide-on-single-page="paginate.singleHidePage"
					@current-change="current_change">
				</el-pagination>
			  </div>
		  </div>
	  </div>
	  <v-footer></v-footer>
  </div>
</template>

<script>
import vHeader from '../common/header'
import vFooter from '../common/footer'
import vStrategyList from '../common/strategy_list'
export default {
	data(){
		return {
			strategyList:[],
			paginate:{
				// "total":12,
				"pageCount":0,
				"layout":"prev, pager, next",
				"currentPage":1,
				"singleHidePage":true,
			},
		};
	},
	components: {
      'v-header': vHeader,
	  'v-footer':vFooter,
	  'v-strategyList':vStrategyList
    },
	mounted() {
		this.getBullStrategyList();
	},
	methods:{
		getBullStrategyList(){
			//+-----------------构建请求参数----------------------
			let data = {
				pageNow:this.paginate.currentPage,
				applicationType:this.store.state.applicationType,
				listCode:2,
				searchContent:'',
			};
			//+-----------------获取牛策略列表---------------------
			this.apiServer.bullStrategy.getList(this.qs.stringify(data))
			.then(res => {
				// console.log('获取牛策略列表',res)
				if(res.data.code == 200){
					if(res.data.data.businessCode != 10){
						this.$message.error(res.data.data.businessMessage);
						return false;
					}
					//更新牛策略数据
					this.strategyList = res.data.data.niuContentList;
					//更新页码
					this.paginate.pageCount = res.data.data.totalPage;
				}
			})
			.catch(res => {
				this.$message.error('获取牛策略数据异常');
			});
		},
		//列表页码改变事件
		current_change:function(currentPage){
			//+---------------更新页码------------------------
			this.paginate.currentPage = currentPage;
			
			//+---------------请求新页码数据------------------
			this.getBullStrategyList();
		},
	}
}
</script>

<style scoped>
	.bullStrategy{
		width: 1180px;
		margin: 0 auto;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/bull_strategy/bullStrategy.vue